<script setup lang="ts">
// TODO провести рефакторинг
import './style.scss';

import { UiIcon } from '@shared/ui';
import type { UiBadgeProps } from './types';
import { NuxtLink } from '#components';

const className = 'ui-badge';

const {
  label,
  labelPre,
  tag = 'span',
  icon,
  href,
  target = '_self',
  rel,
  color = 'neutral',
  size = 'sm',
} = defineProps<UiBadgeProps>();

const getTagName = computed<string | typeof NuxtLink>(() => tag === 'a' ? NuxtLink : tag);

const getRel = computed<string | null>(() => rel ?? null);

const isValid = computed(() => {
  if (icon) {
    return true;
  }
  switch (typeof label) {
    case 'string':
      return !!label;
    case 'number':
      return !!label;
    default:
      return label?.value;
  }
});
</script>

<template>
  <component
    :is="getTagName"
    v-if="isValid"
    :href="href"
    :target="tag === 'a' ? target : null"
    :rel="getRel"
    :class="[
      className,
      {
        [`${className}_action`]: tag === 'a' || tag === 'button',
        [`${className}_${color}`]: color,
        [`${className}_${size}`]: size,
      },
    ]"
  >
    <span
      v-if="labelPre"
      :class="`${className}__label`"
    >{{ labelPre }}</span>
    <UiIcon
      v-if="icon"
      :name="icon"
      :class="`${className}__icon`"
    />
    <span
      v-if="label"
      :class="`${className}__label`"
    >{{ label }}</span>
  </component>
</template>
